import axios from "axios";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import "./App.css";
import "../src/assets/CSS/GlobalModule.css";
import "./Components/Admin/Adminlogin.css";
import "../src/assets/CSS/GlobalModule.css";
import VideoCall from "./VideoCall";

// Testing Development branch

// Main Layout
import AdminLayout from "./Components/Admin/MasterLayout";
import AuditionAdminLayout from "./Components/AuditionAdmin/MasterLayout";
import JuryLayout from "./Components/JuryBoard/MasterLayout";
import StarLayout from "./Components/SuperStar/MasterLayout";

//Private Route
import AdminPrivateRoute from "./Components/PrivateRoute/AdminPrivateRoute";
import AuditionAdminPrivateRoute from "./Components/PrivateRoute/AuditionAdminPrivateRoute";
import SuperStarRoute from "./Components/PrivateRoute/SuperStarRoute";

// Individual Route for Admin
import AdminLogin from "./Components/Admin/AdminLogin";
import AdminOTP from "./Components/Admin/AdminOTP";
import AdminPannel from "./Components/Admin/AdminPannel";
import AdminRegistration from "./Components/Admin/AdminRegistratoin";

// Individual Route for Audion Admin
import AuditionAdminOTP from "./Components/AuditionAdmin/AdminOTP";

// Individual Route for Star
import HelloSuperStarShakib from "./Components/Admin/Home/Pages/Congratulations/HelloSuperStarShakib";
import SuperStarOTP from "./Components/SuperStar/SuperStarOtp";
import SuperStarQR from "./Components/SuperStar/SuperStarQR";
import SuperStarRegistration from "./Components/SuperStar/SuperStarRegistration";
import SuperStarRegistrationOTP from "./Components/SuperStar/SuperStarRegistrationOtp";

// Extra New Route
import RegisterLeftCard from "./Components/Admin/Home/Pages/LiveChatSpStar/RegisterUser/component/RegisterLeftCard";
import SuperstarRoute from "./Components/SuperStar/SuperstarRoute";

import "./assets/CSS/AuditonAdmin.css";
import NotFound from "./Components/Pages/Errors/Error";
import JuryBoardRoute from "./Components/PrivateRoute/JuryBoardRoute";
import LiveCall from "./LiveCall";
import VideoSdk from "./VideoSdk";
import { useState, createContext, useEffect } from "react";

export const serverInfo = createContext();

/**
 * backend connection
 */
// const backendEngUrl = "https://tfpbackend.hellosuperstars.com";
const socketEngUrl = "https://socket.hellosuperstars.com";
// const socketEngUrl = "http://192.168.0.197:3005";

// const backendEngUrl = "http://10.10.10.188/HelloSuperStarsBackend/public";

const backendEngUrl = "https://backend.hellosuperstars.com";
//  const backendEngUrl = "http://localhost/HelloSuperStarsBackend/public/";
// const backendEngUrl = "https://apihss.textware.lk";

// const backendEngUrl = "http://localhost:8000";

// const backendEngUrl = "http://10.10.10.129:8000";
// const backendEngUrl = "http://ec2-13-250-1-56.ap-southeast-1.compute.amazonaws.com";

// const backendEngUrl = "http://localhost:8000";

//const socketEngUrl = "http://10.10.10.129:3005";

// Connect with Backend with Laravel Sanctum Authentication //
axios.defaults.withCredentials = true;
axios.defaults.headers.post["Content-Type"] = "application/json";
axios.defaults.headers.post["Accept"] = "application/json";
axios.defaults.baseURL = backendEngUrl;

axios.interceptors.request.use(function (config) {
  const token = localStorage.getItem("auth_token");
  config.headers.Authorization = token ? `Bearer ${token}` : "";
  return config;
});
// -------------------------------------------------------- //
// stop inspect
// document.addEventListener('contextmenu', function(e) {
//   e.preventDefault();
// });

// document.onkeydown = (e) => {
//   if (e.key == 123) {
//       e.preventDefault();
//   }
//   if (e.ctrlKey && e.shiftKey && e.key == 'I') {
//       e.preventDefault();
//   }
//   if (e.ctrlKey && e.shiftKey && e.key == 'C') {
//       e.preventDefault();
//   }
//   if (e.ctrlKey && e.shiftKey && e.key == 'J') {
//       e.preventDefault();
//   }
//   if (e.ctrlKey && e.key == 'U') {
//       e.preventDefault();
//   }
// };

//  PREVENT CLIPBOARD COPYING
// document.addEventListener("copy", evt => {
//   evt.clipboardData.setData("text/plain", "Copying is not allowed on this website");
//   evt.preventDefault();
// }, false);

function App() {
  const [imageCdnUrl, setImageCdnUrl] = useState(
    "https://d35vkepp4dfq5y.cloudfront.net/"
  );
  const [videoCdnUrl, setIVideoCdnUrl] = useState(
    "https://d2d6zdxlahy4vh.cloudfront.net/"
  );
  const [serverUrl, setServerUrl] = useState(
    "http://10.10.10.159/backend/public/"
  );

  const [shoketUrl, setShoketUrl] = useState(socketEngUrl + "/");
  return (
    <>
      <serverInfo.Provider
        value={{ imageCdnUrl, videoCdnUrl, serverUrl, shoketUrl }}
      >
        <Router>
          <Switch>
            <Route exact path="/video-meeting" component={VideoSdk} />
            {/* Individual Admin Route */}
            <Route exact path="/" component={AdminPannel} />
            <Route
              exact
              path="/superstar-portal/login"
              component={AdminLogin}
            />
            <Route
              exact
              path="/superstar-admin/registration"
              component={AdminRegistration}
            />
            <Route exact path="/superstar-admin/otp" component={AdminOTP} />

            {/* Individual SuperStar Route */}
            <Route
              exact
              path="/superstar/registration"
              component={SuperStarRegistration}
            />
            <Route exact path="/superstar/qr" component={SuperStarQR} />
            <Route exact path="/superstar/otp" component={SuperStarOTP} />
            <Route
              exact
              path="/superstar/congratulations"
              component={HelloSuperStarShakib}
            />
            <Route
              exact
              path="/superstar_registration/otp"
              component={SuperStarRegistrationOTP}
            />

            <SuperStarRoute
              exact
              path="/superstar/Live-chat/pedning-session"
              component={SuperstarRoute}
            />
            <SuperStarRoute
              exact
              path="/superstar/Live-chat/pedning-session/view/:id"
              component={SuperstarRoute}
            />
            <SuperStarRoute
              exact
              path="/superstar/Live-chat/star-live/leftcard"
              component={RegisterLeftCard}
            />

            <Route
              exact
              path="/jury-board/registration"
              component={SuperStarRegistration}
            />
            <Route exact path="/jury-board/otp" component={SuperStarOTP} />
            <Route
              exact
              path="/jury-board-registration/otp"
              component={SuperStarRegistrationOTP}
            />
            <Route
              exact
              path="/jury-board/congratulations"
              component={HelloSuperStarShakib}
            />

            {/* Individual Admin Route */}
            <Route
              exact
              path="/audition-admin/otp"
              component={AuditionAdminOTP}
            />

            <Route exact path="/videoCall" component={VideoCall} />
            <Route exact path="/live-call" component={LiveCall} />
            <Route
              exact
              path="/learning-session/live-stream"
              component={VideoCall}
            />

            {/* Private Route with Main Layout */}
            <AdminPrivateRoute
              path="/superstar-admin"
              name="Admin"
              render={(props) => <AdminLayout {...props} />}
            />
            <SuperStarRoute
              path="/superstar"
              name="SuperStar"
              render={(props) => <StarLayout {...props} />}
            />
            <JuryBoardRoute
              path="/jury-board"
              name="JuryBoard"
              render={(props) => <JuryLayout {...props} />}
            />
            <AuditionAdminPrivateRoute
              path="/audition-admin"
              name="audition-admin-private-route"
              render={(props) => <AuditionAdminLayout {...props} />}
            />

            {/* Error Route */}
            <Route path="/404" component={NotFound} />
            <Route component={NotFound} />
          </Switch>
        </Router>
      </serverInfo.Provider>
    </>
  );
}

export default App;
export { backendEngUrl }